import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  plus20p0vtfmu0596 as plus,
  plus310ted5e4i90h as plus_0,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { filter184huxd00uyfg as filter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  updatePublished2dsy69cya4hmm as updatePublished,
  pushChanges2hvomzqg6xzor as pushChanges,
} from '../../../utils/Draft.ext.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../nav/crowpay.mjs';
import {
  SpecViewDialogyrrvx4h1xg27 as SpecViewDialog,
  EditSpecViewDialog335omt1pbpcw2 as EditSpecViewDialog,
} from '../../dialogs/SpecViewDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  SpecViewgfdgv6h7w5ti as SpecView,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { EditSpecificationItem2oupkkbghtex5 as EditSpecificationItem } from './EditSpecificationItem.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_contractorko2ied3oyiyr as get_contractor } from '../../../../../../crowpay-shared/com/crowpay/SpecificationFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { mutableRememberSuspending34dudnx7ur0xn as mutableRememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRememberSuspending.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  filterNullKeys1r8wmaox0efdd as filterNullKeys,
  truncate3gvhc1a2is66m as truncate,
  resize3py5p2yrjp6p7 as resize,
} from '../../../utils/utils.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  timesx4ey3un7ihw1 as times,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_italic11nskfy97pz2f as get_italic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
} from '../../theming/sections.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_withoutPadding21hnjxk91b1qc as get_withoutPadding } from '../../theming/appTheme.mjs';
import { scopeSetIcon1d64me82i5zfn as scopeSetIcon } from '../iconShortcuts.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../expansion.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$mutableRememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ii3_1.ci3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_2 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp_1 = $this.ii3_1.ji3(item, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  return destination;
}
function *_generator_invoke__zhh2q8_0($this, scope, items, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ki3_1.di3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = asSequence(tmp$ret$0);
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = filter(tmp_0, (it) => items.t1(it.ai2_1)).m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.crowpay.utils.updatePublished' call
    var this_1 = element.ci2_1;
    var tmp_1 = awaitOnce(this_1.aak(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1.c84(VOID, VOID, scope);
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_3 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
    var tmp_4 = updatePublished(this_1, tmp_2, tmp$ret$2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.li3_1.di3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = item.ci2_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  var tmp_2 = destination;
  tmp.zgd(new (SpecViewDialog())(tmp_2, VOID, true, EditSpecifications$render$slambda$slambda_0($this.li3_1)));
  return Unit_instance;
}
var EditSpecifications$render$slambda$slambdaClass;
function EditSpecifications$render$slambda$slambda() {
  if (EditSpecifications$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ki3_1 = this$0;
      }
      mi3(scope, items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, scope, items), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof SpecView() ? p1 : THROW_CCE();
        return this.mi3(tmp, (!(p2 == null) ? isInterface(p2, KtSet()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditSpecifications$render$slambda$slambdaClass = $;
  }
  return EditSpecifications$render$slambda$slambdaClass;
}
function EditSpecifications$render$slambda$slambda_0(this$0) {
  var i = new (EditSpecifications$render$slambda$slambda())(this$0);
  var l = (scope, items, $completion) => i.mi3(scope, items, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, scope, items, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ni3_1.di3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = asSequence(tmp$ret$0);
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = filter(tmp_0, (it) => items.t1(it.ai2_1)).m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.crowpay.utils.updatePublished' call
    var this_1 = element.ci2_1;
    var tmp_1 = awaitOnce(this_1.aak(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1.c84(VOID, VOID, scope);
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_3 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
    var tmp_4 = updatePublished(this_1, tmp_2, tmp$ret$2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.oi3_1.di3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = item.ci2_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  var tmp_2 = destination;
  tmp.zgd(new (SpecViewDialog())(tmp_2, VOID, false, EditSpecifications$render$slambda$slambda_2($this.oi3_1)));
  return Unit_instance;
}
var EditSpecifications$render$slambda$slambdaClass_0;
function EditSpecifications$render$slambda$slambda_1() {
  if (EditSpecifications$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ni3_1 = this$0;
      }
      mi3(scope, items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, scope, items), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof SpecView() ? p1 : THROW_CCE();
        return this.mi3(tmp, (!(p2 == null) ? isInterface(p2, KtSet()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditSpecifications$render$slambda$slambdaClass_0 = $;
  }
  return EditSpecifications$render$slambda$slambdaClass_0;
}
function EditSpecifications$render$slambda$slambda_2(this$0) {
  var i = new (EditSpecifications$render$slambda$slambda_1())(this$0);
  var l = (scope, items, $completion) => i.mi3(scope, items, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.pi3_1.qi3(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var newForm = tmp;
  var tmp_0 = modify($this.pi3_1.di3_1, EditSpecifications$render$slambda$slambda_4(newForm), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.pi3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = newForm.ci2_1;
  var tmp_2 = await_0(this_0, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  tmp_1.hi3_1 = tmp_2.s83_1;
  newForm.ei2_1.oam(true);
  return Unit_instance;
}
var EditSpecifications$render$slambda$slambdaClass_1;
function EditSpecifications$render$slambda$slambda_3() {
  if (EditSpecifications$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($newForm) {
        this.ri3_1 = $newForm;
      }
      si3(it, $completion) {
        return plus(it, this.ri3_1);
      }
      s2(p1, $completion) {
        return this.si3((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$render$slambda$slambdaClass_1 = $;
  }
  return EditSpecifications$render$slambda$slambdaClass_1;
}
function EditSpecifications$render$slambda$slambda_4($newForm) {
  var i = new (EditSpecifications$render$slambda$slambda_3())($newForm);
  var l = (it, $completion) => i.si3(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ti3_1.di3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = item.ci2_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  tmp.zgd(new (SpecViewDialog())(destination, $this.ui3_1.vi3_1, false));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zi3_1.di3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = item.ci2_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  tmp.zgd(new (EditSpecViewDialog())(destination, $this.ai4_1.vi3_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.qfv_1;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bi4_1.di3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var forms = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = forms.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.ci2_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var draft = tmp_0;
    var tmp0_safe_receiver = draft.u83_1;
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m82_1, $this.ci4_1.vi3_1.m82_1)) {
      var tmp_1 = modify(element.ci2_1, EditSpecifications$render$lambda$slambda$slambda$slambda_0(), $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = forms.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_2 = pushChanges(element_0.ci2_1, EditSpecifications$render$lambda$slambda$slambda$slambda_2(), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var EditSpecifications$render$lambda$slambda$slambda$slambdaClass;
function EditSpecifications$render$lambda$slambda$slambda$slambda() {
  if (EditSpecifications$render$lambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      ki2(it, $completion) {
        return it.c84(VOID, VOID, null);
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$render$lambda$slambda$slambda$slambdaClass = $;
  }
  return EditSpecifications$render$lambda$slambda$slambda$slambdaClass;
}
function EditSpecifications$render$lambda$slambda$slambda$slambda_0() {
  var i = new (EditSpecifications$render$lambda$slambda$slambda$slambda())();
  var l = (it, $completion) => i.ki2(it, $completion);
  l.$arity = 1;
  return l;
}
var EditSpecifications$render$lambda$slambda$slambda$slambdaClass_0;
function EditSpecifications$render$lambda$slambda$slambda$slambda_1() {
  if (EditSpecifications$render$lambda$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambda$slambda$slambdaClass_0 = $;
  }
  return EditSpecifications$render$lambda$slambda$slambda$slambdaClass_0;
}
function EditSpecifications$render$lambda$slambda$slambda$slambda_2() {
  var i = new (EditSpecifications$render$lambda$slambda$slambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$lambda$slambda$slambdaClass;
function EditSpecifications$render$lambda$slambda$slambda() {
  if (EditSpecifications$render$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $data) {
        this.bi4_1 = this$0;
        this.ci4_1 = $data;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambda$slambdaClass = $;
  }
  return EditSpecifications$render$lambda$slambda$slambdaClass;
}
function EditSpecifications$render$lambda$slambda$slambda_0(this$0, $data) {
  var i = new (EditSpecifications$render$lambda$slambda$slambda())(this$0, $data);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.di4_1.di3_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = item.ci2_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$2 = tmp_1;
    destination.v(tmp$ret$2);
  }
  tmp.zgd(new (EditSpecViewDialog())(destination, $this.ei4_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.qfv_1;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fi4_1.di3_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var forms = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = forms.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.ci2_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var draft = tmp_0;
    var tmp0_safe_receiver = draft.u83_1;
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m82_1, $this.gi4_1.m82_1)) {
      var tmp_1 = modify(element.ci2_1, EditSpecifications$render$lambda$slambda$slambda$slambda_4(), $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = forms.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_2 = pushChanges(element_0.ci2_1, EditSpecifications$render$lambda$slambda$slambda$slambda_6(), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var EditSpecifications$render$lambda$slambda$slambda$slambdaClass_1;
function EditSpecifications$render$lambda$slambda$slambda$slambda_3() {
  if (EditSpecifications$render$lambda$slambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      ki2(it, $completion) {
        return it.c84(VOID, VOID, null);
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$render$lambda$slambda$slambda$slambdaClass_1 = $;
  }
  return EditSpecifications$render$lambda$slambda$slambda$slambdaClass_1;
}
function EditSpecifications$render$lambda$slambda$slambda$slambda_4() {
  var i = new (EditSpecifications$render$lambda$slambda$slambda$slambda_3())();
  var l = (it, $completion) => i.ki2(it, $completion);
  l.$arity = 1;
  return l;
}
var EditSpecifications$render$lambda$slambda$slambda$slambdaClass_2;
function EditSpecifications$render$lambda$slambda$slambda$slambda_5() {
  if (EditSpecifications$render$lambda$slambda$slambda$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambda$slambda$slambdaClass_2 = $;
  }
  return EditSpecifications$render$lambda$slambda$slambda$slambdaClass_2;
}
function EditSpecifications$render$lambda$slambda$slambda$slambda_6() {
  var i = new (EditSpecifications$render$lambda$slambda$slambda$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$lambda$slambda$slambdaClass_0;
function EditSpecifications$render$lambda$slambda$slambda_1() {
  if (EditSpecifications$render$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $sub) {
        this.fi4_1 = this$0;
        this.gi4_1 = $sub;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambda$slambdaClass_0 = $;
  }
  return EditSpecifications$render$lambda$slambda$slambdaClass_0;
}
function EditSpecifications$render$lambda$slambda$slambda_2(this$0, $sub) {
  var i = new (EditSpecifications$render$lambda$slambda$slambda_1())(this$0, $sub);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, frms, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = frms.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = element.ci2_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp.s83_1.equals($this.hi4_1)) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_13($this, $this$EditSpecificationItem, formId, $completion) {
  var tmp = modify($this.ii4_1.di3_1, EditSpecifications$createForm$make$slambda$slambda_0(formId), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var EditSpecifications$createForm$make$slambda$slambdaClass;
function EditSpecifications$createForm$make$slambda$slambda() {
  if (EditSpecifications$createForm$make$slambda$slambdaClass === VOID) {
    class $ {
      constructor($formId) {
        this.hi4_1 = $formId;
      }
      si3(frms, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, frms), $completion);
      }
      s2(p1, $completion) {
        return this.si3((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$createForm$make$slambda$slambdaClass = $;
  }
  return EditSpecifications$createForm$make$slambda$slambdaClass;
}
function EditSpecifications$createForm$make$slambda$slambda_0($formId) {
  var i = new (EditSpecifications$createForm$make$slambda$slambda())($formId);
  var l = (frms, $completion) => i.si3(frms, $completion);
  l.$arity = 1;
  return l;
}
var SpecGroupClass;
function SpecGroup() {
  if (SpecGroupClass === VOID) {
    class $ {
      constructor(group, topLevelItems, subgroups) {
        this.vi3_1 = group;
        this.wi3_1 = topLevelItems;
        this.xi3_1 = subgroups;
        var tmp = this;
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0 = this.xi3_1;
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = tmp0.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var list = element.f2();
          addAll(destination, list);
        }
        tmp.yi3_1 = plus_0(this.wi3_1, destination);
      }
      toString() {
        return 'SpecGroup(group=' + toString(this.vi3_1) + ', topLevelItems=' + toString_0(this.wi3_1) + ', subgroups=' + toString_0(this.xi3_1) + ')';
      }
      hashCode() {
        var result = this.vi3_1 == null ? 0 : this.vi3_1.hashCode();
        result = imul(result, 31) + hashCode(this.wi3_1) | 0;
        result = imul(result, 31) + hashCode(this.xi3_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpecGroup()))
          return false;
        if (!equals(this.vi3_1, other.vi3_1))
          return false;
        if (!equals(this.wi3_1, other.wi3_1))
          return false;
        if (!equals(this.xi3_1, other.xi3_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpecGroup');
    SpecGroupClass = $;
  }
  return SpecGroupClass;
}
function *_generator_createForm__ryli94($this, spec, $completion) {
  var tmp;
  if (spec == null) {
    tmp = createForm$make(spec, $this);
  } else {
    var tmp0_safe_receiver = $this.gi3_1.p3(spec.s83_1);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'com.crowpay.utils.updatePublished' call
      var this_0 = tmp0_safe_receiver.ci2_1;
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_1 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
      var tmp$ret$0 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
      var tmp_2 = updatePublished(this_0, spec, tmp$ret$0, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp = tmp1_elvis_lhs == null ? createForm$make(spec, $this) : tmp1_elvis_lhs;
  }
  return tmp;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ji4_1 = function_0;
      }
      wi(a, b) {
        return this.ji4_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ji4_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function createForm$make($spec, this$0) {
  var form = new (EditSpecificationItem())($spec, this$0.ai3_1, EditSpecifications$createForm$make$slambda_0(this$0), this$0.bi3_1);
  var tmp0 = this$0.gi3_1;
  // Inline function 'kotlin.collections.set' call
  var key = form.ai2_1;
  tmp0.s3(key, form);
  return form;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(_this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? get_expanding(_this__u8e3s4) : Companion_getInstance();
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderForms_pudkx4(_this__u8e3s4, $data) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_rem(0));
  var _iterator__ex2g4s = $data.wi3_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var spec = _iterator__ex2g4s.o1();
    render(spec, view);
    greySeparator(view);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
var EditSpecifications$_init_$slambda_31r5daClass;
function EditSpecifications$_init_$slambda_31r5da() {
  if (EditSpecifications$_init_$slambda_31r5daClass === VOID) {
    class $ {
      ki2(it, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$_init_$slambda_31r5daClass = $;
  }
  return EditSpecifications$_init_$slambda_31r5daClass;
}
function EditSpecifications$_init_$slambda_31r5da_0() {
  var i = new (EditSpecifications$_init_$slambda_31r5da())();
  var l = (it, $completion) => i.ki2(it, $completion);
  l.$arity = 1;
  return l;
}
var EditSpecifications$forms$slambdaClass;
function EditSpecifications$forms$slambda() {
  if (EditSpecifications$forms$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ii3_1 = this$0;
      }
      yah($this$mutableRememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$mutableRememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecifications$forms$slambdaClass = $;
  }
  return EditSpecifications$forms$slambdaClass;
}
function EditSpecifications$forms$slambda_0(this$0) {
  var i = new (EditSpecifications$forms$slambda())(this$0);
  var l = ($this$mutableRememberSuspending, $completion) => i.yah($this$mutableRememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function EditSpecifications$specGroups$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = !(a.vi3_1 == null);
  var tmp$ret$1 = !(b.vi3_1 == null);
  return compareValues(tmp, tmp$ret$1);
}
var EditSpecifications$render$slambdaClass;
function EditSpecifications$render$slambda() {
  if (EditSpecifications$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.li3_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$slambdaClass = $;
  }
  return EditSpecifications$render$slambdaClass;
}
function EditSpecifications$render$slambda_0(this$0) {
  var i = new (EditSpecifications$render$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$slambdaClass_0;
function EditSpecifications$render$slambda_1() {
  if (EditSpecifications$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.oi3_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$slambdaClass_0 = $;
  }
  return EditSpecifications$render$slambdaClass_0;
}
function EditSpecifications$render$slambda_2(this$0) {
  var i = new (EditSpecifications$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$slambdaClass_1;
function EditSpecifications$render$slambda_3() {
  if (EditSpecifications$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.pi3_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$slambdaClass_1 = $;
  }
  return EditSpecifications$render$slambdaClass_1;
}
function EditSpecifications$render$slambda_4(this$0) {
  var i = new (EditSpecifications$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_visible_$ref_cygc3o(p0) {
  return () => p0.ab9();
}
function TextView$_set_visible_$ref_rs9jjk(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var EditSpecifications$render$lambda$slambdaClass;
function EditSpecifications$render$lambda$slambda() {
  if (EditSpecifications$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $data) {
        this.ti3_1 = this$0;
        this.ui3_1 = $data;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambdaClass = $;
  }
  return EditSpecifications$render$lambda$slambdaClass;
}
function EditSpecifications$render$lambda$slambda_0(this$0, $data) {
  var i = new (EditSpecifications$render$lambda$slambda())(this$0, $data);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$lambda$slambdaClass_0;
function EditSpecifications$render$lambda$slambda_1() {
  if (EditSpecifications$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $data) {
        this.zi3_1 = this$0;
        this.ai4_1 = $data;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambdaClass_0 = $;
  }
  return EditSpecifications$render$lambda$slambdaClass_0;
}
function EditSpecifications$render$lambda$slambda_2(this$0, $data) {
  var i = new (EditSpecifications$render$lambda$slambda_1())(this$0, $data);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$lambda$slambdaClass_1;
function EditSpecifications$render$lambda$slambda_3() {
  if (EditSpecifications$render$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, $data, this$0) {
        this.ki4_1 = $$this$button;
        this.li4_1 = $data;
        this.mi4_1 = this$0;
      }
      uao($completion) {
        var tmp = 'Delete ' + this.li4_1.vi3_1.n82_1 + '?';
        var tmp_0 = DangerButtonSemantic_getInstance();
        confirmationDialog(this.ki4_1, tmp, 'This cannot be undone.', 'Delete', VOID, tmp_0, VOID, VOID, VOID, VOID, EditSpecifications$render$lambda$slambda$slambda_0(this.mi4_1, this.li4_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambdaClass_1 = $;
  }
  return EditSpecifications$render$lambda$slambdaClass_1;
}
function EditSpecifications$render$lambda$slambda_4($$this$button, $data, this$0) {
  var i = new (EditSpecifications$render$lambda$slambda_3())($$this$button, $data, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function EditSpecifications$render$lambda$lambda($items) {
  return ($this$remember) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $items;
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp0_elvis_lhs = $this$remember.daj(element.ci2_1).x83_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.r91(0n);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$0 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
    }
    var tmp$ret$1 = sum;
    return new (MonetaryValue())(tmp$ret$1);
  };
}
function TextView$_get_visible_$ref_cygc3o_0(p0) {
  return () => p0.ab9();
}
function TextView$_set_visible_$ref_rs9jjk_0(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function EditSpecifications$render$lambda$lambda_0($this, $price) {
  return ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__compareTo_impl_w7ul1r($this$reactiveScope.daj($price).y5r_1, Companion_instance.m62(0)) > 0;
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function EditSpecifications$render$lambda$lambda_1($this, $price) {
  return ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj($price).y5r_1);
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
var EditSpecifications$render$lambda$slambdaClass_2;
function EditSpecifications$render$lambda$slambda_5() {
  if (EditSpecifications$render$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $sub) {
        this.di4_1 = this$0;
        this.ei4_1 = $sub;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambdaClass_2 = $;
  }
  return EditSpecifications$render$lambda$slambdaClass_2;
}
function EditSpecifications$render$lambda$slambda_6(this$0, $sub) {
  var i = new (EditSpecifications$render$lambda$slambda_5())(this$0, $sub);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$render$lambda$slambdaClass_3;
function EditSpecifications$render$lambda$slambda_7() {
  if (EditSpecifications$render$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($$this$button, $sub, this$0) {
        this.ni4_1 = $$this$button;
        this.oi4_1 = $sub;
        this.pi4_1 = this$0;
      }
      uao($completion) {
        var tmp = 'Delete ' + this.oi4_1.n82_1 + '?';
        var tmp_0 = DangerButtonSemantic_getInstance();
        confirmationDialog(this.ni4_1, tmp, 'This cannot be undone.', 'Delete', VOID, tmp_0, VOID, VOID, VOID, VOID, EditSpecifications$render$lambda$slambda$slambda_2(this.pi4_1, this.oi4_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecifications$render$lambda$slambdaClass_3 = $;
  }
  return EditSpecifications$render$lambda$slambdaClass_3;
}
function EditSpecifications$render$lambda$slambda_8($$this$button, $sub, this$0) {
  var i = new (EditSpecifications$render$lambda$slambda_7())($$this$button, $sub, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecifications$createForm$make$slambdaClass;
function EditSpecifications$createForm$make$slambda() {
  if (EditSpecifications$createForm$make$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ii4_1 = this$0;
      }
      bhr($this$EditSpecificationItem, formId, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$EditSpecificationItem, formId), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.bhr(tmp, p2 instanceof UUID() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditSpecifications$createForm$make$slambdaClass = $;
  }
  return EditSpecifications$createForm$make$slambdaClass;
}
function EditSpecifications$createForm$make$slambda_0(this$0) {
  var i = new (EditSpecifications$createForm$make$slambda())(this$0);
  var l = ($this$EditSpecificationItem, formId, $completion) => i.bhr($this$EditSpecificationItem, formId, $completion);
  l.$arity = 2;
  return l;
}
var EditSpecificationsClass;
function EditSpecifications() {
  if (EditSpecificationsClass === VOID) {
    class $ {
      constructor(contractorId, onSave) {
        var tmp;
        if (onSave === VOID) {
          tmp = EditSpecifications$_init_$slambda_31r5da_0();
        } else {
          tmp = onSave;
        }
        onSave = tmp;
        this.ai3_1 = contractorId;
        this.bi3_1 = onSave;
        var tmp_0 = this;
        tmp_0.ci3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).qfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp$ret$4 = eq(get_contractor(it), this.ai3_1);
          return tmp.mdw(new (Query())(tmp$ret$4, VOID, VOID, 2147483647));
        });
        var tmp_1 = this;
        tmp_1.di3_1 = mutableRememberSuspending(VOID, VOID, EditSpecifications$forms$slambda_0(this));
        var tmp_2 = this;
        tmp_2.ei3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.di3_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = $this$remember.daj(element.ci2_1).u83_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          return destination;
        });
        var tmp_3 = this;
        tmp_3.fi3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var grouped = $this$remember.daj(this.ei3_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = LinkedHashMap().f6();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = grouped.d2().m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.e2();
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q82_1) == null) {
              destination.s3(element.e2(), element.f2());
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(destination.p1());
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = destination.d2().m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.collections.component1' call
            var group = item.e2();
            // Inline function 'kotlin.collections.component2' call
            var items = item.f2();
            var tmp;
            if (group == null) {
              tmp = emptyMap();
            } else {
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_1 = LinkedHashMap().f6();
              // Inline function 'kotlin.collections.iterator' call
              var _iterator__ex2g4s_1 = grouped.d2().m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_0 = _iterator__ex2g4s_1.o1();
                var tmp0_safe_receiver_0 = element_0.e2();
                if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q82_1, group.m82_1)) {
                  destination_1.s3(element_0.e2(), element_0.f2());
                }
              }
              tmp = filterNullKeys(destination_1);
            }
            var tmp$ret$21 = new (SpecGroup())(group, items, tmp);
            destination_0.v(tmp$ret$21);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_0 = EditSpecifications$specGroups$lambda$lambda;
          var tmp$ret$24 = new (sam$kotlin_Comparator$0())(tmp_0);
          return sortedWith(destination_0, tmp$ret$24);
        });
        this.gi3_1 = HashMap().n8();
        this.hi3_1 = null;
      }
      ji3(spec, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_createForm__ryli94.bind(VOID, this, spec), $completion);
      }
      qi3(spec, $completion, $super) {
        spec = spec === VOID ? null : spec;
        return $super === VOID ? this.ji3(spec, $completion) : $super.ji3.call(this, spec, $completion);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.gba(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 0.2);
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        var tmp = get_viewIsWide(view_0) ? get_atEnd(view_0) : Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().vgf();
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowCollapsingToColumn())(view_0.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(false);
        var tmp_0 = view_3.kbb(render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_3), get_secondaryButton(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        specCenteredText(view_4, '+ Spec Set');
        onClick(view_4, VOID, VOID, EditSpecifications$render$slambda_0(this));
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_0, view_4);
        var tmp_1 = view_3.kbb(render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_3), get_secondaryButton(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.gbb(p_5, view_5);
        specCenteredText(view_5, '+ Spec View');
        onClick(view_5, VOID, VOID, EditSpecifications$render$slambda_2(this));
        view_3.hbb(p_5, view_5);
        view_3.lbb(tmp_1, view_5);
        view_2.hbb(p_3, view_3);
        var tmp_2 = get_tertiaryButton(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_6 = view_2.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
        view_2.gbb(p_6, view_6);
        specCenteredText(view_6, '+ New Specification');
        onClick(view_6, VOID, VOID, EditSpecifications$render$slambda_4(this));
        view_2.hbb(p_6, view_6);
        view_2.lbb(tmp_2, view_6);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_7 = view_0.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_0 : tmp0_elvis_lhs_7;
        view_0.gbb(p_7, view_7);
        view_0.hbb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_8 = view_0.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_0 : tmp0_elvis_lhs_8;
        view_0.gbb(p_8, view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_9.zbm(true);
        view_9.bb9(times(view_9.mba().jb0_1, 1.2));
        var expandedCache = HashMap().n8();
        forEach(view_9, this.fi3_1, ($this$forEach, data) => {
          var tmp;
          if (data.vi3_1 == null) {
            render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderForms_pudkx4($this$forEach, data);
            return Unit_instance;
          }
          var tmp_0 = get_compact($this$forEach);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEach.pc());
          var tmp0_elvis_lhs = $this$forEach.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
          $this$forEach.gbb(p, view);
          view.zbm(true);
          var tmp0 = expandedCache;
          // Inline function 'kotlin.collections.getOrPut' call
          var key = data.vi3_1.m82_1;
          var value = tmp0.p3(key);
          var tmp_1;
          if (value == null) {
            var answer = Signal().hak(true);
            tmp0.s3(key, answer);
            tmp_1 = answer;
          } else {
            tmp_1 = value;
          }
          var expanded = tmp_1;
          var tmp_2 = view.kbb(get_lightSection(view), get_unpadded(view));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.daj(expanded) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
          var tmp_3 = get_expanding(view_0);
          view_0.lbb(tmp_3, leftExpandButton(view_0, expanded, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
            var tmp;
            if (data.vi3_1.p82_1) {
              $this$leftExpandButton.lbb(get_centered($this$leftExpandButton), scopeSetIcon($this$leftExpandButton, get_rem_0(1.3)));
              tmp = Unit_instance;
            }
            $this$leftExpandButton.lbb($this$leftExpandButton.kbb(get_viewIsNarrow($this$leftExpandButton) ? get_expanding($this$leftExpandButton) : Companion_getInstance(), get_centered($this$leftExpandButton)), bodyBold($this$leftExpandButton, data.vi3_1.n82_1));
            var tmp_0;
            if (get_viewIsWide($this$leftExpandButton)) {
              // Inline function 'com.lightningkite.kiteui.views.direct.space' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (Space())($this$leftExpandButton.pc(), 0.1);
              var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
              var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
              $this$leftExpandButton.gbb(p, view);
              $this$leftExpandButton.hbb(p, view);
              var tmp_1 = $this$leftExpandButton.kbb($this$leftExpandButton.kbb(get_expanding($this$leftExpandButton), get_centered($this$leftExpandButton)), get_italic($this$leftExpandButton));
              var tmp0_safe_receiver = data.vi3_1.o82_1;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : truncate(tmp0_safe_receiver, 50);
              $this$leftExpandButton.lbb(tmp_1, smallBody($this$leftExpandButton, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
              tmp_0 = Unit_instance;
            }
            var tmp_2 = get_centered($this$leftExpandButton);
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (TextView())($this$leftExpandButton.pc());
            var tmp0_elvis_lhs_0 = $this$leftExpandButton.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? $this$leftExpandButton : tmp0_elvis_lhs_0;
            $this$leftExpandButton.gbb(p_0, view_0);
            view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
            var price = remember(VOID, VOID, VOID, ($this$remember) => {
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var this_0 = data.yi3_1;
              var sum = Companion_instance.r91(0n);
              var _iterator__ex2g4s = this_0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                var tmp = sum;
                var tmp0_elvis_lhs = $this$remember.daj(element.ci2_1).x83_1;
                var tmp_0;
                var tmp_1 = tmp0_elvis_lhs;
                if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
                  tmp_0 = Companion_instance.r91(0n);
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var tmp$ret$27 = tmp_0;
                sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$27);
              }
              var tmp$ret$28 = sum;
              return new (MonetaryValue())(tmp$ret$28);
            });
            var tmp_3 = KMutableProperty0();
            var tmp_4 = TextView$_get_visible_$ref_cygc3o(view_0);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('visible', 0, tmp_3, tmp_4, TextView$_set_visible_$ref_rs9jjk(view_0));
            reactiveScope(view_0, ($this$reactiveScope) => {
              var tmp$ret$29 = MonetaryValue__compareTo_impl_w7ul1r($this$reactiveScope.daj(price).y5r_1, Companion_instance.m62(0)) > 0;
              this_0.set(tmp$ret$29);
              return Unit_instance;
            });
            var tmp_5 = KMutableProperty0();
            var tmp_6 = TextView$_get_content_$ref_4pzcwl(view_0);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(view_0));
            reactiveScope(view_0, ($this$reactiveScope) => {
              var tmp$ret$31 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(price).y5r_1);
              this_1.set(tmp$ret$31);
              return Unit_instance;
            });
            $this$leftExpandButton.hbb(p_0, view_0);
            $this$leftExpandButton.lbb(tmp_2, view_0);
            return Unit_instance;
          }));
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Space())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_0.hbb(p_1, view_1);
          var tmp_4 = get_padded(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          view_2.zbm(false);
          view_2.bb9(get_AppDimensions().og2_1);
          var tmp_5 = get_textButton(view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          view_3.gba(get_dp(4));
          view_3.lbb(get_centered(view_3), body(view_3, '+ Group'));
          onClick(view_3, VOID, VOID, EditSpecifications$render$lambda$slambda_0(this, data));
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_5, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Button())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.gba(get_dp(4));
          view_4.lbb(get_centered(view_4), icon(view_4, resize(get_edit(Companion_getInstance_0()), get_rem_0(1.1)), 'Edit Group'));
          onClick(view_4, VOID, VOID, EditSpecifications$render$lambda$slambda_2(this, data));
          view_2.hbb(p_4, view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Button())(view_2.pc());
          var tmp0_elvis_lhs_5 = view_2.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
          view_2.gbb(p_5, view_5);
          view_5.gba(get_dp(4));
          view_5.lbb(get_centered(view_5), icon(view_5, resize(get_trash(Companion_getInstance_0()), get_rem_0(1.1)), 'Delete Group'));
          onClick(view_5, VOID, VOID, EditSpecifications$render$lambda$slambda_4(view_5, data, this));
          view_2.hbb(p_5, view_5);
          view_0.hbb(p_2, view_2);
          view_0.lbb(tmp_4, view_2);
          view.hbb(p_0, view_0);
          view.lbb(tmp_2, view_0);
          var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(expanded));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_6 = view.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
          view.gbb(p_6, view_6);
          view_6.zbm(true);
          render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderForms_pudkx4(view_6, data);
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!data.xi3_1.i1()) {
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_7 = new (RowOrCol())(view_6.pc());
            var tmp0_elvis_lhs_7 = view_6.ebb_1;
            var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
            view_6.gbb(p_7, view_7);
            view_7.zbm(true);
            // Inline function 'kotlin.collections.iterator' call
            var _iterator__ex2g4s = data.xi3_1.d2().m1();
            while (_iterator__ex2g4s.n1()) {
              var _destruct__k2r9zo = _iterator__ex2g4s.o1();
              // Inline function 'kotlin.collections.component1' call
              var sub = _destruct__k2r9zo.e2();
              // Inline function 'kotlin.collections.component2' call
              var items = _destruct__k2r9zo.f2();
              var tmp_7 = view_7.kbb(get_lightSection(view_7), get_compact(view_7));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_8 = new (RowOrCol())(view_7.pc());
              var tmp0_elvis_lhs_8 = view_7.ebb_1;
              var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
              view_7.gbb(p_8, view_8);
              view_8.zbm(false);
              view_8.lbb(view_8.kbb(view_8.kbb(get_viewIsNarrow(view_8) ? get_expanding(view_8) : Companion_getInstance(), get_centered(view_8)), get_padded(view_8)), bodyBold(view_8, sub.n82_1));
              if (get_viewIsWide(view_8)) {
                // Inline function 'com.lightningkite.kiteui.views.direct.space' call
                // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
                var view_9 = new (Space())(view_8.pc(), 0.1);
                var tmp0_elvis_lhs_9 = view_8.ebb_1;
                var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
                view_8.gbb(p_9, view_9);
                view_8.hbb(p_9, view_9);
                var tmp_8 = view_8.kbb(view_8.kbb(get_expanding(view_8), get_centered(view_8)), get_italic(view_8));
                var tmp0_safe_receiver = sub.o82_1;
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : truncate(tmp0_safe_receiver, 50);
                view_8.lbb(tmp_8, smallBody(view_8, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
              }
              var tmp_9 = get_centered(view_8);
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_10 = new (TextView())(view_8.pc());
              var tmp0_elvis_lhs_10 = view_8.ebb_1;
              var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
              view_8.gbb(p_10, view_10);
              view_10.lba(view_10.qb6_1.abf(BodySemantic_getInstance()));
              var price = remember(VOID, VOID, VOID, EditSpecifications$render$lambda$lambda(items));
              var tmp_10 = KMutableProperty0();
              var tmp_11 = TextView$_get_visible_$ref_cygc3o_0(view_10);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_0 = getPropertyCallableRef('visible', 0, tmp_10, tmp_11, TextView$_set_visible_$ref_rs9jjk_0(view_10));
              reactiveScope(view_10, EditSpecifications$render$lambda$lambda_0(this_0, price));
              var tmp_12 = KMutableProperty0();
              var tmp_13 = TextView$_get_content_$ref_4pzcwl_0(view_10);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_1 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_0(view_10));
              reactiveScope(view_10, EditSpecifications$render$lambda$lambda_1(this_1, price));
              view_8.hbb(p_10, view_10);
              view_8.lbb(tmp_9, view_10);
              // Inline function 'com.lightningkite.kiteui.views.direct.space' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_11 = new (Space())(view_8.pc());
              var tmp0_elvis_lhs_11 = view_8.ebb_1;
              var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
              view_8.gbb(p_11, view_11);
              view_8.hbb(p_11, view_11);
              var tmp_14 = get_padded(view_8);
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_12 = new (RowOrCol())(view_8.pc());
              var tmp0_elvis_lhs_12 = view_8.ebb_1;
              var p_12 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
              view_8.gbb(p_12, view_12);
              view_12.zbm(false);
              view_12.bb9(get_AppDimensions().og2_1);
              // Inline function 'com.lightningkite.kiteui.views.direct.button' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_13 = new (Button())(view_12.pc());
              var tmp0_elvis_lhs_13 = view_12.ebb_1;
              var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
              view_12.gbb(p_13, view_13);
              view_13.gba(get_dp(4));
              view_13.lbb(get_centered(view_13), icon(view_13, resize(get_edit(Companion_getInstance_0()), get_rem_0(1.1)), 'Edit Group'));
              onClick(view_13, VOID, VOID, EditSpecifications$render$lambda$slambda_6(this, sub));
              view_12.hbb(p_13, view_13);
              // Inline function 'com.lightningkite.kiteui.views.direct.button' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_14 = new (Button())(view_12.pc());
              var tmp0_elvis_lhs_14 = view_12.ebb_1;
              var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
              view_12.gbb(p_14, view_14);
              view_14.gba(get_dp(4));
              view_14.lbb(get_centered(view_14), icon(view_14, resize(get_trash(Companion_getInstance_0()), get_rem_0(1.1)), 'Delete Group'));
              onClick(view_14, VOID, VOID, EditSpecifications$render$lambda$slambda_8(view_14, sub, this));
              view_12.hbb(p_14, view_14);
              view_8.hbb(p_12, view_12);
              view_8.lbb(tmp_14, view_12);
              view_7.hbb(p_8, view_8);
              view_7.lbb(tmp_7, view_8);
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_15 = new (RowOrCol())(view_7.pc());
              var tmp0_elvis_lhs_15 = view_7.ebb_1;
              var p_15 = tmp0_elvis_lhs_15 == null ? view_7 : tmp0_elvis_lhs_15;
              view_7.gbb(p_15, view_15);
              view_15.zbm(true);
              view_15.bb9(get_rem(0));
              var _iterator__ex2g4s_0 = items.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var spec = _iterator__ex2g4s_0.o1();
                render(spec, view_15);
                greySeparator(view_15);
              }
              view_7.hbb(p_15, view_15);
            }
            view_6.hbb(p_7, view_7);
          }
          view.hbb(p_6, view_6);
          view.lbb(tmp_6, view_6);
          $this$forEach.hbb(p, view);
          $this$forEach.lbb(tmp_0, view);
          return Unit_instance;
        });
        view_8.hbb(p_9, view_9);
        var tmp_3 = get_centered(view_8);
        var tmp_4 = view_8.kbb(tmp_3, shownWhen(view_8, VOID, ($this$shownWhen) => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = $this$shownWhen.faj(this.fi3_1);
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
          return !!(tmp instanceof InternalReactiveNotReady());
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (ActivityIndicator())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.gbb(p_10, view_10);
        view_8.hbb(p_10, view_10);
        view_8.lbb(tmp_4, view_10);
        view_0.hbb(p_8, view_8);
        view.hbb(p_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'EditSpecifications', VOID, VOID, [Page()], [1, 0]);
    EditSpecificationsClass = $;
  }
  return EditSpecificationsClass;
}
//region block: exports
export {
  EditSpecifications as EditSpecifications2oyd85jvpdaul,
};
//endregion

//# sourceMappingURL=EditSpecifications.mjs.map
